<app-window-title title="Add Library Web Source"
                  [closable]="true"></app-window-title>
<div  class="fx-col fx-jc-center fx-ai-center fx-gap-10">
  <mat-card>
    <mat-card-title>
      Add Library Web Source
    </mat-card-title>
    <mat-card-content>
      <form [formGroup]="urlForm"
            (ngSubmit)="addUrl()">
        <mat-form-field appearance="fill">
          <mat-label>
            Title
          </mat-label>
          <input formControlName="title"
                 matInput>
          <mat-error *ngIf="urlForm.get('title').hasError('required')">
            Title is required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>
            URL
          </mat-label>
          <input formControlName="url"
                 matInput>
          <mat-error *ngIf="urlForm.get('url').hasError('required')">
            URL is required
          </mat-error>
          <mat-error *ngIf="urlForm.get('url').hasError('pattern')">
            Invalid URL
          </mat-error>
        </mat-form-field>
        <button color="primary"
                type="submit"
                mat-raised-button
                [disabled]="urlForm.invalid">
          Add URL
        </button>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="urls.length > 0">
    <mat-card-title>
      Added URLs
    </mat-card-title>
    <mat-card-content>
      <mat-list>
        <mat-list-item *ngFor="let url of urls; let i = index">
          <div  class="fx-flex-100pct fx-row fx-jc-between fx-ai-center">
            <div>
              <h4 matLine>
                {{url.title}}
              </h4>
              <p matLine>
                {{url.url}}
              </p>
            </div>
            <button color="warn"
                    mat-icon-button
                    (click)="deleteUrl(i)">
              <mat-icon>
                delete
              </mat-icon>
            </button>
          </div>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
    <mat-card-actions>
      <button color="primary"
              mat-raised-button
              (click)="saveUrls()">
        Save Sources
      </button>
    </mat-card-actions>
  </mat-card>
</div>
